import { T } from "services/lang/LanguageService";

const groupedUnits = [
  {
    label: T("unit.temperature"),
    value: 'temperature',
    items: [
      {
        label: '°C',
        value: '°C',
      },
    ],
  },
  {
    label: T("unit.speed"),
    value: 'speed',
    items: [
      {
        label: 'rpm',
        value: 'rpm',
      },
      {
        label: 'Hz',
        value: 'Hz',
      },
      {
        label: 'm/s',
        value: 'm/s',
      },
    ],
  },
  {
    label: T("unit.area"),
    value: 'area',
    items: [
      {
        label: 'm²',
        value: 'm²',
      },
    ],
  },
  {
    label: T("unit.electricity"),
    value: 'electricity',
    items: [
      {
        label: 'V',
        value: 'V',
      },
      {
        label: 'A',
        value: 'A',
      },
    ],
  },
  {
    label: T("unit.volume"),
    value: 'volume',
    items: [
      {
        label: 'L',
        value: 'L',
      },
      {
        label: 'm³',
        value: 'm³',
      },
    ],
  },
  {
    label: T("unit.flow-rate"),
    value: 'flowRate',
    items: [
      {
        label: 'm³/h',
        value: 'm³/h',
      },
      {
        label: 'L/min',
        value: 'L/min',
      },
      {
        label: 'mm/h',
        value: 'mm/h',
      },
    ],
  },
  {
    label: T("unit.work"),
    value: 'work',
    items: [
      {
        label: 'Wh',
        value: 'Wh',
      }
    ],
  },
  {
    label: T("unit.pressure"),
    value: 'pressure',
    items: [
      {
        label: 'bar',
        value: 'bar',
      },
      {
        label: 'Pa',
        value: 'Pa',
      },
      {
        label: 'hPa',
        value: 'hPa',
      },
      {
        label: 'psi',
        value: 'psi',
      },
    ],
  },
  {
    label: T("unit.power"),
    value: 'power',
    items: [
      {
        label: 'W',
        value: 'W',
      },
    ],
  },
  {
    label: T("unit.percentage"),
    value: 'percentage',
    items: [
      {
        label: '%',
        value: '%',
      },
    ],
  },
];

export default groupedUnits;